class TabbedJournalFeed extends HTMLElement {
  connectedCallback() {
    this.tabsContainer = this.querySelector('[data-journal-tabs]');
    this.querySelectorAll('[data-journal-unit] > [role="tab"]').forEach((tab) => this.tabsContainer?.append(tab));
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.panels = [...this.querySelectorAll('[role="tabpanel"]')];

    if (this.tabsContainer) this.tabsContainer.hidden = this.tabs.length <= 1;

    this.addEventListener('click', this.onClick);
    this.addEventListener('keydown', this.onKeydown);

    if (window.Shopify?.designMode) {
      this.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    const activeTab = this.tabs.find((tab) => tab.classList.contains('is-active')) || this.tabs[0];
    if (activeTab) this.activate(activeTab.dataset.tabId);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('keydown', this.onKeydown);
    this.removeEventListener('shopify:block:select', this.onBlockSelect);
  }

  onClick = (event) => {
    const tab = event.target.closest('[role="tab"]');
    if (tab && this.contains(tab)) this.activate(tab.dataset.tabId);
  };

  onKeydown = (event) => {
    const currentIndex = this.tabs.indexOf(event.target);
    if (currentIndex < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

    event.preventDefault();
    let nextIndex = currentIndex;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
    this.activate(this.tabs[nextIndex].dataset.tabId, true);
  };

  onBlockSelect = (event) => this.activate(event.detail.blockId);

  activate(id, focus = false) {
    const activeTab = this.tabs.find((tab) => tab.dataset.tabId === id);
    const activePanel = this.panels.find((panel) => panel.dataset.panelId === id);
    if (!activeTab || !activePanel) return;

    this.tabs.forEach((tab) => {
      const isActive = tab === activeTab;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel !== activePanel;
    });

    activePanel.querySelector('slideshow-slides')?.scrollTo({ left: 0, behavior: 'instant' });
    if (focus) activeTab.focus();
    requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
  }
}

if (!customElements.get('tabbed-journal-feed')) {
  customElements.define('tabbed-journal-feed', TabbedJournalFeed);
}
